module.exports = __webpack_public_path__ + "static/thy-yeni-1-ce954f0afbc829fd4deb1974dc07e1c8.png";